import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  bodyText: {
    margin: [theme.spacing('medium'), 0],
  },
  list: {
    listStyle: 'initial',
    listStylePosition: 'inside',
    marginBottom: theme.spacing('xlarge'),
  },
  listItem: {
    marginBottom: theme.spacing('medium'),
  },
  image: {
    width: '100%',
    marginBottom: theme.spacing('medium'),
  },
}));
